import {useCallback, useState} from "react";
import ReferralAccount from "./referral-account";

export function useReferralAccount() {
    const [referralLoading, setReferralLoading] = useState(false);

    const getReferralAccount = useCallback(async () => {
        const response = await new ReferralAccount().getMine();
        return response?.data || null;
    }, []);

    const redeemPoints = useCallback(async ({points, idempotencyKey}) => {
        setReferralLoading(true);
        try {
            const response = await new ReferralAccount().redeem({points, idempotencyKey});
            return response?.data || null;
        } finally {
            setReferralLoading(false);
        }
    }, []);

    const registerReferral = useCallback(async ({referralCode, idempotencyKey}) => {
        setReferralLoading(true);
        try {
            const response = await new ReferralAccount().register({referralCode, idempotencyKey});
            return response?.data || null;
        } finally {
            setReferralLoading(false);
        }
    }, []);

    return {getReferralAccount, registerReferral, redeemPoints, referralLoading};
}
